import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpApiService} from './http-api.service';
import {PlanningRegion} from '../../models/planning_region.model';
import {Contact} from "../../models/contact.model";
import {Regions} from "../../models/region.model";

@Injectable({
  providedIn: 'root'
})
export class PlanningRegionApiService {
  private readonly planningRegionEndpoint = 'planning_region/';
  private readonly planningRegionGroupsEndpoint = 'planning_region/groups';
  private readonly removeReservationEndpoint = 'planning_region/remove_reservation';
  private readonly contactsEndpoint = 'planning_region/contacts';
  private readonly exportEndpoint = 'planning_region/export_etat';
  private readonly deleteScreenCommentEndpoint = 'planning_region/delete_screen_comment';
  private readonly addScreenCommentEndpoint = 'planning_region/add_screen_comment';
  private readonly progAnnonceEndpoint = 'planning_region/prog_annonce';

  private reloadPlanningSubject = new BehaviorSubject<number | null>(null);
  reloadPlanningRegion$ = this.reloadPlanningSubject.asObservable();

  private reloadReserDetailsSubject = new BehaviorSubject<number | null>(null);
  reloadReserDetails$ = this.reloadReserDetailsSubject.asObservable();

  constructor(private httpApiService: HttpApiService) {}

  public fetchRegionData(cookies: string, idRegion: number, wedn: string): Observable<PlanningRegion> {
    const params = { id_group: idRegion, wedn: wedn };
    return this.httpApiService.get<PlanningRegion>(this.planningRegionEndpoint, params, cookies);
  }

  public fetchGroups(cookies: string): Observable<Regions> {
    return this.httpApiService.get<Regions>(this.planningRegionGroupsEndpoint, cookies);
  }

  public reloadPlanningRegion(regionId: number): void {
    this.reloadPlanningSubject.next(regionId);
  }

  public reloadDetailsReservation(id_reser: number): void {
    this.reloadReserDetailsSubject.next(id_reser);
  }

  public removeReservation(cookies: string, idReser: number, wedn: string): Observable<any> {
    const params = { id_reser: idReser, wedn: wedn };
    return this.httpApiService.post<any>(this.removeReservationEndpoint, params, cookies);
  }

  public fetchContacts(cookies: string, idCinema: number): Observable<Contact> {
    return this.httpApiService.get<Contact>(this.contactsEndpoint, { id_cinema: idCinema }, cookies);
  }

  public exportEtat(cookies: string, params?: any): Observable<any> {
    return this.httpApiService.get<any>(this.exportEndpoint, params, cookies);
  }

  saveComment(cookies: string, comment: any): Observable<any> {
    return this.httpApiService.post<any>(this.addScreenCommentEndpoint, comment, cookies);
  }

  deleteComment(cookies: string, commentId: number): Observable<any> {
    return this.httpApiService.delete<any>(this.deleteScreenCommentEndpoint, {'id_comment': commentId}, cookies);
  }

  updateProgAnnonce(cookies: string, id_cinema: number, date: string): Observable<any> {
    return this.httpApiService.post<any>(this.progAnnonceEndpoint, {'id_cinema': id_cinema, 'date': date}, cookies);
  }
}
